// Maps backend constant values to i18n keys.
// Use tConst(value, t) to render a translated label while leaving the raw
// value untouched where it is used for business logic.

import i18n from './i18n';

const MAP = {
  'In Stock': 'part_status_in_stock',
  'Out of Stock': 'part_status_out_of_stock',
  'Reserved': 'part_status_reserved',
  'Sent to Wastage': 'part_status_wastage',
  'Compatible': 'ref_type_compatible',
  'Written on the label': 'ref_type_label',
  'New': 'condition_new',
  'Used': 'condition_used',
  'ReManufactured': 'condition_remanufactured',
  'Remanufactured': 'condition_remanufactured',
  'Not working(for parts)': 'condition_not_working',
  'Not working (for parts)': 'condition_not_working',
  'Affects function': 'damage_type_affect',
  'Affect function': 'damage_type_affect',
  'Not affect function': 'damage_type_not_affect',
  'Does not affect function': 'damage_type_not_affect',
  'Internal': 'damage_location_internal',
  'External': 'damage_location_external',

  // API error/success messages (auth)
  'Email and Password are invalid!': 'auth_invalid_credentials',
  'Email or Password are invalid!': 'auth_invalid_credentials',
  'Email must be required.': 'auth_err_email_required',
  'Enter valid email address.': 'auth_err_email_invalid',
  'Password must be required.': 'auth_err_password_required',
  'Login success': 'auth_login_success',
  'Token invalid!': 'auth_token_invalid',
  'Your account is not verified.': 'auth_account_not_verified',
  'Your account has been blocked.': 'auth_account_blocked',
  'Email not found.': 'auth_email_not_found',
  'Email already exists.': 'auth_email_exists',
  'Email address is not registered.': 'auth_email_not_registered',
  'OTP is invalid.': 'auth_otp_invalid',
  'OTP has expired.': 'auth_otp_expired',
  'OTP must be required.': 'auth_otp_required',
  'Invalid OTP, please verify that you have entered correct OTP': 'auth_otp_wrong',
  'We have emailed you otp,please reset your password.': 'auth_otp_sent',
  'Please enter password for reset': 'auth_reset_password_required',
  'Password reset successfully.': 'auth_password_reset_ok',
  'Password not matched.': 'auth_password_not_matched',
  'Token must be required.': 'auth_token_required',
  'Oops..Something want wrong. Please try again!': 'auth_err_generic',
  'Oops...something went wrong. Please contact to support team.': 'contact_err_generic',
  'Oops...something went wrong. Please try again.': 'auth_err_generic',

  // Contact form validation messages (backend: CompanyController.addContactUS)
  'Name must be required.': 'contact_err_name',
  'Email must be required.': 'contact_err_email',
  'Enter valid email address.': 'contact_err_email_invalid',
  'Mobile number must be required.': 'contact_err_mobile',
  'Message must be required.': 'contact_err_message',
  'Already exists.': 'contact_err_exists',
  'Thank You for connecting with us.': 'contact_ok',
  'Oops...something went wrong. Please contact to support team.': 'contact_err_generic',

  // Profile & Users
  'Profile successfully fetch': 'msg_profile_fetched',
  'Your profile information has been updated successfully.': 'msg_profile_updated',
  'Name must be required.': 'msg_name_required',
  'Country  must be required.': 'msg_country_required',
  'Country must be required.': 'msg_country_required',
  'State number must be required.': 'msg_state_required',
  'City number must be required.': 'msg_city_required',
  'Zipcode number must be required.': 'msg_zipcode_required',
  'Invalid zipcode number.': 'msg_zipcode_invalid',
  'Address must be required.': 'msg_address_required',
  'User has been successfully created.': 'msg_user_created',
  'User has been successfully updated.': 'msg_user_updated',
  'User has been successfully deleted.': 'msg_user_deleted',

  // Common API messages
  'parts inventory has been successfully created.': 'msg_inventory_created',
  'parts inventory has been successfully updated.': 'msg_inventory_updated',
  'Inventory part has been successfully deleted.': 'msg_inventory_deleted',
  'Your part has been replicated successfully.': 'msg_inventory_replicated',
  'parts images successfully added.': 'msg_images_added',
  'Images order updated successfully.': 'msg_images_reordered',
  'Inventory part image successfully deleted.': 'msg_image_deleted',
  'parts video successfully added.': 'msg_video_added',
  'Video order updated successfully.': 'msg_videos_reordered',

  // Moloni — status labels
  'Draft': 'moloni_status_draft',
  'Issued': 'moloni_status_issued',
  'Cancelled': 'moloni_status_cancelled',
  'Closed/Final': 'moloni_status_closed',
  'Closed/Finalized': 'moloni_status_closed',
  'Finalized': 'moloni_status_closed',
  'Closed': 'moloni_status_closed',
  'Pending': 'moloni_status_pending',
  'Accepted': 'moloni_status_accepted',
  'Delivered': 'moloni_status_delivered',
  'Refunded': 'moloni_status_refunded',

  // Moloni — document types
  'Invoice': 'moloni_doctype_invoice',
  'Simplified Invoice': 'moloni_doctype_simplified_invoice',
  'Invoice + Receipt': 'moloni_doctype_invoice_receipt',
  'Credit Note': 'moloni_doctype_credit_note',
  'Debit Note': 'moloni_doctype_debit_note',
  'Delivery Note': 'moloni_doctype_delivery_note',
  'Receipt': 'moloni_doctype_receipt',
  'Estimate': 'moloni_doctype_estimate',
  'Purchase Order': 'moloni_doctype_purchase_order',
  'Bills of Lading': 'moloni_doctype_bills_of_lading',
  'Bill of Lading': 'moloni_doctype_bills_of_lading',
  'Global Guide': 'moloni_doctype_global_guide',
  'Global Guides': 'moloni_doctype_global_guide',
  'Waybill': 'moloni_doctype_waybill',
  'Waybills': 'moloni_doctype_waybill',
  'Own Assets Movement': 'moloni_doctype_own_assets',
  'Internal Document': 'moloni_doctype_internal_document',
  'Internal Documents': 'moloni_doctype_internal_document',
  'Customer Return Note': 'moloni_doctype_customer_return',
  'Customer Return Notes': 'moloni_doctype_customer_return',
  'Supplier Return Note': 'moloni_doctype_supplier_return',
  'Payment Return': 'moloni_doctype_payment_return',
  'Payment Returns': 'moloni_doctype_payment_return',
  'Warranty Request': 'moloni_doctype_warranty_request',

  // Part check status (verificação de peças)
  'Not Checked': 'part_check_status_not_checked',
  'In Progress': 'part_check_status_in_progress',
  'Checked': 'part_check_status_checked',
  'Rejected': 'part_check_status_rejected',
  'Approved': 'part_check_status_approved',
  'Needs Review': 'part_check_status_needs_review',
  'To Check': 'part_check_status_to_check',

  // Part converted check status (estado de conversão)
  'Not Converted': 'part_converted_not',
  'Converted': 'part_converted_yes',
  'Partially Converted': 'part_converted_partial',
  'Cancelled Conversion': 'part_converted_cancelled',

  // Vehicle table columns (vehicle-process + similar)
  'Vehicle Internal ID': 'col_vehicle_internal_id',
  'Vehicle Internal Id': 'col_vehicle_internal_id',
  'Internal ID': 'col_vehicle_internal_id',
  'Internal Id': 'col_vehicle_internal_id',
  'Registration No.': 'col_registration_no',
  'Registration No': 'col_registration_no',
  'Registration Plate': 'col_registration_no',
  'Vehicle Make': 'col_vehicle_make',
  'Make': 'col_vehicle_make',
  'Vehicle Model': 'col_vehicle_model',
  'Model': 'col_vehicle_model',
  'Vehicle Year': 'col_vehicle_year',
  'Year': 'col_vehicle_year',
  'VIN': 'col_vin',
  'Vehicle Owner': 'col_vehicle_owner',
  'Owner': 'col_vehicle_owner',
  'Stock Status': 'col_stock_status',
  'Inventory Status': 'col_stock_status',
  'Depollution Status': 'col_depollution_status',
  'Dismantle Status': 'col_dismantle_status',
  'Vehicle Park': 'col_vehicle_park',
  'Park': 'col_vehicle_park',
  'Process Start Date': 'col_process_start_date',
  'Process End Date': 'col_process_end_date',
  'Created At': 'col_created_at',
  'Created Date': 'col_created_at',
  'created Date': 'col_created_at',
  'Updated At': 'col_updated_at',
  'Expiry Date': 'col_expiry_date',
  'expiry Date': 'col_expiry_date',
  'Action': 'col_action',

  // Park / parking slot status
  'In Park': 'park_status_in_park',
  'Sent To Waste': 'park_status_sent_to_waste',
  'Sent to Waste': 'park_status_sent_to_waste',

  // Depollution status values
  'In Depllution': 'depollution_status_in_progress',
  'In Depollution': 'depollution_status_in_progress',
  'Depolluted': 'depollution_status_completed',

  // Dismantle status values
  'In Dismentaling': 'dismantle_status_in_progress',
  'In Dismantling': 'dismantle_status_in_progress',
  'Dismentalled': 'dismantle_status_completed',
  'Dismantled': 'dismantle_status_completed',

  // Parking state (StateParking.json)
  'With declaration': 'state_parking_with_declaration',
  'With certificate': 'state_parking_with_certificate',
  'Pending to accept': 'state_parking_pending_accept',
};

export const tConst = (value, t) => {
  if (!value) return '';
  const trimmed = typeof value.trim === 'function' ? value.trim() : value;
  const key = MAP[trimmed] || MAP[value];
  if (!key) return value;
  const translated = t(key);
  return translated === key ? value : translated;
};

export default tConst;

// Standalone variant that uses i18next directly (no need to pass `t`).
// Useful for helpers called outside React components (e.g. Utils.getErrorMessage).
export const tConstStatic = (value) => {
  if (!value) return '';
  const trimmed = typeof value.trim === 'function' ? value.trim() : value;
  const key = MAP[trimmed] || MAP[value];
  if (!key) return value;
  const translated = i18n.t(key);
  return translated === key ? value : translated;
};
